import { INTEGRATION_SOURCE_DISPLAY_NAMES } from '@factoryfixinc/ats-interfaces';

// An applicant's integrationId is stored as "<source>:<externalId>" (e.g. "greenhouse:aBcD1234").
// These helpers resolve the leading source segment to a human-readable ATS name, or undefined
// when the value is missing/malformed (i.e. the applicant did not come from an ATS integration).

export const getIntegrationSourceFromId = (integrationId?: string | null): string | undefined => {
  if (typeof integrationId !== 'string') {
    return undefined;
  }

  const separatorIndex = integrationId.indexOf(':');
  if (separatorIndex <= 0) {
    return undefined;
  }

  return integrationId.slice(0, separatorIndex);
};

export const getIntegrationDisplayName = (integrationId?: string | null): string | undefined => {
  const source = getIntegrationSourceFromId(integrationId);
  if (!source) {
    return undefined;
  }

  // Own-property guard: a malformed source segment (e.g. "toString", "constructor")
  // must not resolve to an inherited Object.prototype member.
  return Object.prototype.hasOwnProperty.call(INTEGRATION_SOURCE_DISPLAY_NAMES, source)
    ? INTEGRATION_SOURCE_DISPLAY_NAMES[source]
    : undefined;
};
